import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import './PhotoPreview.scss';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';
import ResponsivePicture from '../../Elements/ResponsivePicture/ResponsivePicture';
import { constructCn } from '../../../utilities/helperFunctions';

const injectedTransforms = {
    close: 'f_auto,q_auto,c_scale',
};
const closeBtnSrc = buildImagePath(
    '/v1/SVGs/circle_x.svg',
    'close',
    injectedTransforms
);

const PhotoPreview = ({ image, send, editMode }) => {
    const handlePreviewClose = useCallback(() => {
        send('SET_IMAGE_TO_DEFAULT');
        EmitMetric({
            misc_event_type: 'photo-preview-user-close',
            misc_event_count: 1,
            cloudinary_id: image?.src,
        });
    }, [image, send]);
    const previewClass = constructCn(
        'component-UnifiedPostBox-PhotoPreview',
        editMode && 'editmode'
    );
    const mobilemax = editMode ? 444 : 300;
    return (
        <div className={previewClass}>
            <div className="relative-container">
                {!editMode && (
                    <button
                        className="close-button"
                        onClick={handlePreviewClose}
                        type="submit"
                    >
                        <img src={closeBtnSrc} alt="clear-preview-icon" />
                    </button>
                )}
                <ResponsivePicture
                    cloudinaryID={image?.src}
                    className="preview-image"
                    breakpoints={{
                        mobile: {
                            width: mobilemax,
                            height: mobilemax,
                            transforms: { crop: 'limit' },
                        },
                    }}
                />
            </div>
        </div>
    );
};

PhotoPreview.propTypes = {
    image: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string,
    }).isRequired,
    send: PropTypes.func.isRequired,
    editMode: PropTypes.bool,
};

PhotoPreview.defaultProps = {
    editMode: false,
};

PhotoPreview.displayName = 'PhotoPreview';

export default React.memo(PhotoPreview);
